import { IonCard } from '@ionic/react';
import React from 'react';
import { IFiscalizacion } from '../../services/Fiscalizacion/Fiscalizacion';

interface IAreaFiscMap {
    nombre: string;
    ico: string;
    url: string;
    puntoDeServicio: string;
    fis_id: number;
}

const areasFiscMap: IAreaFiscMap[] = [
	{nombre: "Personal", ico: "COD1", url: "fiscalizarpersonal",  fis_id: 0, puntoDeServicio: '' },
	{nombre: "Deposito", ico: "COD2", url: "fiscalizardeposito", fis_id: 0, puntoDeServicio: '' },
	{nombre: "Maquinas", ico: "COD3", url: "fiscalizarmaquina", fis_id: 0, puntoDeServicio: ''},
	{nombre: "Nivel de Limpieza General", ico: "COD4", url: "fiscalizarlimpieza", fis_id:0, puntoDeServicio: '' },
	{nombre: "Stock de Productos", ico: "COD6", url: "fiscalizarstock", fis_id: 0, puntoDeServicio: ''},
    {nombre: "Opinion del Cliente", ico: "COD5", url: "fiscalizaropinion", fis_id: 0, puntoDeServicio: ''},
];

interface BotonAreaProps extends IFiscalizacion {
    iniciarFiscalizacion: (url: string) => void;
    cod_ID:number;
    id: number;
    opcion: string;
    ob_id: number;
    fis_id: number;
    ps_id: number;
  }

const BotonArea: React.FC<BotonAreaProps> = ({ cod_ID, id, ob_id, fis_id, ps_id, iniciarFiscalizacion }) => {
    const item = id != null ? areasFiscMap[id-1] : null;

    if (!item) {
        return null;
    }

    const cardClass = `fiscalizacion_btn ${ob_id === cod_ID ? 'active' : ''}`;

    return (
        <IonCard key={cod_ID} onClick={() => iniciarFiscalizacion(item.url)} className={cardClass}>
            <img src={`assets/icon/fisc-${item.ico}.svg`} alt={``} />
            <h3>{item.nombre}</h3>
        </IonCard>
    );
}

export default BotonArea;
